module.exports = __webpack_public_path__ + "img/face46.381b28f7.gif";